/**
 * Vite 地圖宿主入口 — 打包 core + cabinets
 */
import { bus } from '../../public/js/core/sovereign-bus.js';
import { initSovereignMap } from '../../public/js/core/map-init.js';
import { appCore } from '../../public/js/core/MapApp.js';

import '../../public/js/cabinets/bus/index.js';
import '../../public/js/cabinets/rail/index.js';
import '../../public/js/cabinets/roads/index.js';
import '../../public/js/cabinets/poi/index.js';
import '../../public/js/cabinets/youbike/index.js';
import '../../public/js/cabinets/retail/index.js';
import '../../public/js/cabinets/parking/index.js';
import '../../public/js/cabinets/consultant/index.js';
import '../../public/js/cabinets/map-locate/index.js';
import '../../public/js/cabinets/isochrone/index.js';
import '../../public/js/cabinets/price/index.js';
import '../../public/js/cabinets/screenshot/index.js';
import '../../public/js/cabinets/screenshot-test/index.js';
import { ensureCabinetsDocked } from '../../public/js/core/cabinet-dock.js';
import { readMapFocusQuery, applyMapFocus } from '../../public/js/utils/map-focus-from-query.js';
import { initUrbanRenewalLayer } from '../../public/js/modules/urban-renewal-layer.js';

export async function bootMapHost({ authenticated = false, user = null } = {}) {
    console.log('🚀 [SOVEREIGN-BOOT] Map host bundle initializing...');
    bus.emit('SOVEREIGN_AUTH', { authenticated, user });
    ensureCabinetsDocked(appCore);
    const map = initSovereignMap('map-container');
    appCore.setMapInstance(map);
    ensureCabinetsDocked(appCore);
    initUrbanRenewalLayer(map);
    bus.emit('MAP_READY', { engine: 'Leaflet', version: '1.9.4' });
    applyMapFocus(map, readMapFocusQuery());
}

if (typeof window !== 'undefined' && window.__SOVEREIGN_MAP_BOOT__) {
    const payload = window.__SOVEREIGN_MAP_BOOT__;
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => bootMapHost(payload));
    } else {
        bootMapHost(payload);
    }
}
